<template>
  <AppAlert color="primary" icon="mdi:lock-check" class="mb-2">
    {{ $tt('we_are_pci_compliant', { year: getCurrentYear() }) }}
  </AppAlert>
  <AppAlert icon="mdi:shield-half-full" class="mb-5">
    {{ $tt('privacy_security_importance') }}
  </AppAlert>
  <h3>{{ $tt('payment') }}</h3>
  <AppRow class="my-6">
    <p>
      <strong>
        <AppIcon icon="mdi:check-circle-outline" color="success" start />
        {{ $tt('our_payment_methods') }}
      </strong>
    </p>
    <PaymentLogos />
  </AppRow>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';
</script>